/**
 * @generated SignedSource<<ec51ca1d55d5334b05bc295f2062a11f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type IntegrationEmaginFlyerStatus = "failed" | "pending" | "success";
import { FragmentRefs } from "relay-runtime";
export type IntegrationAdminFlyerListItem_IntegrationEmaginFlyer$data = {
  readonly __typename: "IntegrationEmaginFlyer";
  readonly eMaginId: string | null;
  readonly id: string;
  readonly lastCheckedAt: string | null;
  readonly lastError: string | null;
  readonly status: IntegrationEmaginFlyerStatus | null;
  readonly title: string | null;
  readonly " $fragmentType": "IntegrationAdminFlyerListItem_IntegrationEmaginFlyer";
};
export type IntegrationAdminFlyerListItem_IntegrationEmaginFlyer$key = {
  readonly " $data"?: IntegrationAdminFlyerListItem_IntegrationEmaginFlyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminFlyerListItem_IntegrationEmaginFlyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationAdminFlyerListItem_IntegrationEmaginFlyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eMaginId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastCheckedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastError",
      "storageKey": null
    }
  ],
  "type": "IntegrationEmaginFlyer",
  "abstractKey": null
};

(node as any).hash = "99e397e15ad9805ff3194be72141ff74";

export default node;
